import {
  ApiResponse,
  TokenData,
  AddNewDocument,
  LegalDueDiligencesData,
  LegalDueDiligences,
} from "../models";
import * as http from "./http";
import ApiService from "./service";

export class LegalDueDiligenceService extends ApiService {
  public async addNewDocument(data: AddNewDocument) {
    const url = `${this.apiDomain}/api/legal-due-diligence`;

    const response = await http.post<ApiResponse<LegalDueDiligences>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async listByRequirement(
    requirementId: string
  ): Promise<LegalDueDiligencesData> {
    const url = `${this.apiDomain}/api/legal-due-diligence/of-requirement/${requirementId}`;

    const resposne = await http.get<ApiResponse<LegalDueDiligencesData>>(
      url,
      this.store
    );
    return resposne.data?.data;
  }

  public async getLDDdetails(
    documentId: string
  ): Promise<LegalDueDiligencesData> {
    const url = `${this.apiDomain}/api/legal-due-diligence/details/${documentId}`;

    const resposne = await http.get<ApiResponse<LegalDueDiligencesData>>(
      url,
      this.store
    );
    return resposne.data?.data;
  }
  public async uploadDocument(data: any, documentId: string) {
    const url = `${this.apiDomain}/api/legal-due-diligence/upload/${documentId}`;

    const response = await http.post<ApiResponse<any>>(url, data, this.store);
    return response.data?.data;
  }

  public async requestDocument(data: any, id: string) {
    const url = `${this.apiDomain}/api/legal-due-diligence/request/${id}`;

    const response = await http.put<ApiResponse<any>>(url, data, this.store);
    return response.data?.data;
  }

  public async sendDocument(data: any, id: string) {
    const url = `${this.apiDomain}/api/legal-due-diligence/send/${id}`;

    const response = await http.put<ApiResponse<any>>(url, data, this.store);
    return response.data?.data;
  }

  public async approve(data: any) {
    const url = `${this.apiDomain}/api/legal-due-diligence/accept`;

    const response = await http.put<ApiResponse<any>>(url, data, this.store);
    return response.data?.data;
  }

  public async reject(data: any) {
    const url = `${this.apiDomain}/api/legal-due-diligence/reject`;

    const response = await http.put<ApiResponse<any>>(url, data, this.store);
    return response.data?.data;
  }
}
